module.exports = __webpack_public_path__ + "img/nbus_box_2.ca8a2635.jpg";